import type { IFieldDefinition, IRecordTypeDefinition } from '@platform/core/types';

/** Колонки списку вибору посилання (UIUX/forms/form-variants, Lookup): поля `forms.lookup.fields` цільового типу без назви й статусу. */
export function lookupColumns(rt: IRecordTypeDefinition | undefined): IFieldDefinition[] {
  if (!rt) return [];
  return (rt.forms?.lookup?.fields ?? [])
    .filter((k) => k !== 'title' && k !== 'status')
    .map((k) => rt.fields.find((f) => f.key === k))
    .filter((f): f is IFieldDefinition => Boolean(f));
}
